<div [id]="id" @fadeIn>  
  <h1>Section header</h1>
  <!--<button (click)="selectComponent('QuesChoiceResponse')">Do this!</button>-->
  <div>
    <ng-template ques-host></ng-template>
  </div>
  <br />
  <div>
    <app-button title="Add Question" style="float:left" [btnStyle]="btnPlus" [btnType]="btnRnd" [btnColor]="" [btnSize]="btnMedium" (btnClick)="selectComponent('QuesChoiceResponse')"></app-button> &nbsp;
    <app-button style="float:right" [btnStyle]="btnTextOnly" [btnType]="btnRect" [btnColor]="btnColor" [btnSize]="btnMedium" [btnText]="btnText" (btnClick)="removeSection(id)"></app-button> &nbsp;
  </div>
</div>
